import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const GuestRoute = () => {
  const { isAuthenticated } = useAuth();
  return (
    <div>{!isAuthenticated ? <Outlet /> : <Navigate to={"/dashboard"} />}</div>
  );
};

export default GuestRoute;
